import { Component, Inject, Optional } from '@angular/core';
import { NavigationToolsProviderService } from '@services/navigation-tools-provider/navigation-tools-provider.service';
import { REQUEST_LOCALIZE } from '../../../schema/injection-token';
import { RequestLocalization } from '../../../schema/interfaces/request-localization';
import { CallcardComponentCard } from '../callcard-component-card';

@Component({
  selector: 'app-callcard-clocations-card',
  templateUrl: './callcard-clocations-card.component.html',
  styleUrls: ['./callcard-clocations-card.component.scss']
})
export class CallcardClocationsCardComponent extends CallcardComponentCard {
  constructor(
    public navigationTools: NavigationToolsProviderService,
    @Optional()
    @Inject(REQUEST_LOCALIZE)
    private localizer: RequestLocalization
  ) {
    super();
  }

  onLocalize() {
    const location = this.callcard.location;
    if (this.enableInteraction && this.localizer) {
      this.localizer.requestLocalize(location.coordinate);
    }
  }
}
